module.exports = function() {
  return new Worker(__webpack_public_path__ + "c8aa9fed92443167c9b9.worker.js");
};